import {
  ListCollection,
  SelectValueChangeDetails,
  Text,
} from '@chakra-ui/react'
import {
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectTrigger,
  SelectValueText,
  SelectLabel,
} from '../chakraComponents/select'
import { FC } from 'react'

interface ImplementationSelectorProps {
  implementationsCollection: ListCollection<{
    label: string
    value: string
  }>
  setSelectedImplementationId: (implementationId: string) => void
  ref: React.RefObject<HTMLElement | null>
}

export const ImplementationSelector: FC<ImplementationSelectorProps> = ({
  implementationsCollection,
  setSelectedImplementationId,
  ref,
}) => {
  const handleValueChange = ({ value }: SelectValueChangeDetails) => {
    const implementationId = value[0]

    setSelectedImplementationId(implementationId)
  }

  return (
    <SelectRoot
      collection={implementationsCollection}
      size='sm'
      variant={'outline'}
      onValueChange={handleValueChange}>
      <SelectLabel>Select implementation</SelectLabel>
      <SelectTrigger>
        <SelectValueText color={'text.1'} placeholder='Select implementation' />
      </SelectTrigger>
      <SelectContent zIndex={100} portalRef={ref}>
        {implementationsCollection.items.map((i) => (
          <SelectItem item={i} key={i.value}>
            <Text>{i.label}</Text>
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  )
}
